import { Component, DestroyRef, OnInit } from '@angular/core';
import { API } from 'src/app/services/api/api';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-reservation-list',
  templateUrl: './reservation-list.component.html',
  styleUrls: ['./reservation-list.component.scss'],
  standalone: false,
})
export class ReservationListComponent implements OnInit {
  constructor(
    private api: API,
    private destroyRef: DestroyRef
  ) {}

  ngOnInit(): void {
    this.refreshFromServer();
  }

  refreshFromServer() {
    this.api
      .dm_time_Calendar_retrieveAll()
      .pipe(takeUntilDestroyed(this.destroyRef), take(1))
      .subscribe({
        next: () => {},
        error: () => {},
      });
  }
}
